import moment from 'moment';

export const dateFormat = (date) => {
  return moment(date).format('MMMM DD, YYYY');
};

export const timeFormat = (date) => {
  return moment(date).format('HH:mm A');
};
